// src/wsRecovery/index.js

import {
  registerSocket,
  resumeSocket,
  resumeAll
} from "./wsResume";

import { startHeartbeat } from "./heartbeat";
import { initWsRecovery } from "./wsRecoveryManager";

initWsRecovery();
